import React from 'react';
import styled from 'styled-components';
import { Box, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { BillComponent } from '../../../../generated/graphql';
import { BillDetail, InfoLink, ListContainer, SidebarContainer } from '../../../../ui-kit';
import { routePaths } from '../../../../routePaths';
import BillSidebar from './BillSidebar';

interface BillDetailProps {
    billId: string;
}

const Wrapper = styled(Box)`
  ${({ theme }) => `
        ${theme.breakpoints.down('sm')} {
            flex-direction: column;
        }
    `}
`;

const BillDetailList = ({ billId }: BillDetailProps) => {
    const { t } = useTranslation();

    return (
        <BillComponent variables={{ id: billId }}>
            {({ data: { bill } }) => {
                const { order: { name, orderNumber, place } } = bill;
                const placeName = place ? place.name : t('Take away');
                const orderDisplayName = name || orderNumber || placeName;

                return (
                    <Wrapper display='flex' flexGrow={1}>
                        <SidebarContainer>
                            <BillSidebar bill={bill} />
                        </SidebarContainer>
                        <ListContainer>
                            <Box>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <InfoLink
                                            link={`${routePaths.orders}/${bill.order.id}`}
                                            linkText={t('Part of {{orderDisplayName}}', { orderDisplayName })}
                                        />
                                    </Grid>
                                    <Grid item container spacing={3} xs={12}>
                                        {bill.orderLines.map(orderLine => (
                                            <Grid key={orderLine.id} item xs={12} sm={6} lg={3}>
                                                <BillDetail {...orderLine} />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Box>
                        </ListContainer>
                    </Wrapper>
                );
            }}
        </BillComponent>
    );
};

export default BillDetailList;
